import React from 'react';
import { ProfileInfoCard } from './cards/ProfileInfoCard';
import { FeedbackCard } from './cards/FeedbackCard';
import { DeleteAccountCard } from './cards/DeleteAccountCard';
import { PushNotificationSettings } from './PushNotificationSettings';
import { LoadingSkeletons } from './LoadingSkeletons';

interface ProfileContentProps {
  profile: any;
  email: string | undefined | null;
  userId: string | undefined | null;
  isFamilyAdmin: boolean;
  familyAdmin: any;
  familyMembers: any[];
  isLoading: boolean;
  error: Error | null;
  isCreatingProfile: boolean;
  retryProfileLoad: () => void;
}

export const ProfileContent: React.FC<ProfileContentProps> = ({
  profile,
  email,
  userId,
  isFamilyAdmin,
  familyAdmin,
  familyMembers,
  isLoading,
  error,
  isCreatingProfile,
  retryProfileLoad
}) => {
  if (isLoading) {
    return <LoadingSkeletons />;
  }

  if (error) {
    return (
      <div className="text-center">
        <p className="text-red-500">Error loading profile: {error.message}</p>
        <button onClick={retryProfileLoad} className="mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/80">
          Retry Loading Profile
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <ProfileInfoCard
        profile={profile}
        email={email}
        userId={userId}
        isCreatingProfile={isCreatingProfile}
        isFamilyAdmin={isFamilyAdmin}
        familyAdmin={familyAdmin}
      />
      
      
      {/* Push Notification Settings */}
      {userId && <PushNotificationSettings userId={userId} />}
      
      <FeedbackCard />
      
      {/* Delete Account */}
      <DeleteAccountCard 
        familyMembers={familyMembers}
        isFamilyAdmin={isFamilyAdmin}
        email={email}
      />
    </div>
  );
};
